@if (attachments.length > 0) {
  <ion-grid class="grid-collage">
    @for (row of attachmentGrid; track row) {
      <ion-row>
        @for (col of row; track col) {
          <ion-col>
            @if (id(col); as attachment) {
              <div>
                <div>
                  @if (!hasFileSystem) {
                    <img class="fill" [src]="thumbUrl(attachment) | secure | async" />
                  } @else {
                    @if (attachment.thumbUrl) {
                      <a>
                        <img class="fill" [src]="sanitizeUrl(attachment.thumbUrl)" />
                      </a>
                    }
                    @if (!attachment.thumbUrl) {
                      <div></div>
                    }
                  }
                </div>
              </div>
            }
          </ion-col>
        }
      </ion-row>
    }
  </ion-grid>
}
